// extracted by mini-css-extract-plugin
module.exports = {"modalFooterBtnWrapper":"style_modalFooterBtnWrapper__WB3eJ"};